var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSenderPlaceholderIcon = function SvgSenderPlaceholderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 118 118"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "senderPlaceholderIcon_svg__a",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "#A0BEFF",
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#senderPlaceholderIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "#B2DEA1",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#senderPlaceholderIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9FBFF",
    d: "M38 16.687c0-.932.755-1.687 1.687-1.687h44.695l18.171 22.301c.247.303.381.682.379 1.072l-.192 51.687a1.687 1.687 0 0 1-1.687 1.68H39.687A1.687 1.687 0 0 1 38 90.055z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#senderPlaceholderIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m84.2 14.74 18.822 22.816h-17.65a1.17 1.17 0 0 1-1.172-1.172z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 4.663,
    height: 0.389,
    x: 47.357,
    y: 24.818,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.663,
    height: 0.389,
    x: 53.574,
    y: 31.812,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.886,
    height: 0.389,
    x: 47.357,
    y: 27.926,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.497,
    height: 0.389,
    x: 47.357,
    y: 28.315,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-90 47.357 28.315)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.829,
    height: 0.389,
    x: 53.574,
    y: 30.647,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-90 53.574 30.647)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.829,
    height: 0.389,
    x: 64.891,
    y: 32.374,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-121.945 64.891 32.374)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.262,
    height: 0.389,
    x: 60.113,
    y: 29.309,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-46.838 60.113 29.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.109,
    height: 0.389,
    x: 60.18,
    y: 27.927,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-90 60.18 27.927)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.109,
    height: 0.389,
    x: 60.18,
    y: 32.201,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-90 60.18 32.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.72,
    height: 0.389,
    x: 47.357,
    y: 32.201,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.389,
    rx: 0.194,
    transform: "rotate(-90 47.357 32.2)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#senderPlaceholderIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m49.994 49 2.688 1.332-7.994 16.128L42 65.127z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#senderPlaceholderIcon_svg__e)",
    d: "M38 47.5s-9.478 4.5-9.978 7C21.82 75.66 18.5 83.5 17 85.5c.788 4.5 2 16 14.022 6 6.751-5.616 11.166-10.167 12-12.5l10.5-24c2.5-5.5-2.5-7-2.5-7-2.8-.8-5 2-5.5 3l-5.5 13-2.022.956z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#senderPlaceholderIcon_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.022 85-5 5.5-.5 1 18.5 14 6.5-8z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#senderPlaceholderIcon_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0B56FF",
    d: "m10.522 89.5-21.5 24.5c-.8 7.6 20.666 7.167 31.5 6l11-13.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30.022,
    cy: 100,
    r: 1,
    fill: "#272E42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7AC72",
    d: "M53.5 52.065c0-2.4-2.167-3.333-3.5-3-1.6.4-3.333 4.102-3.5 4.935 1.2 1.6 4.167 2 5.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#senderPlaceholderIcon_svg__h)",
    d: "M53 50.5c-.5-1-.857-.864-1.714-1.5-.211.549-2.264 5.357-2.286 6.5.429.636 1.324 0 1.5 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "senderPlaceholderIcon_svg__b",
    width: 68.592,
    height: 80.581,
    x: 34.34,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3.18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.159919 0 0 0 0 0.579167 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_19337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1106_19337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "senderPlaceholderIcon_svg__c",
    width: 20.683,
    height: 24.676,
    x: 82.339,
    y: 14.741,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.141,
    dy: 1.141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_19337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1106_19337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "senderPlaceholderIcon_svg__d",
    width: 18.682,
    height: 25.46,
    x: 35,
    y: 46,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_19337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1106_19337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "senderPlaceholderIcon_svg__f",
    width: 33,
    height: 28.5,
    x: 7.522,
    y: 81,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_19337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1106_19337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "senderPlaceholderIcon_svg__g",
    width: 50.522,
    height: 39.156,
    x: -15,
    y: 85.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_19337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1106_19337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "senderPlaceholderIcon_svg__e",
    x1: 17,
    x2: 52.5,
    y1: 65.5,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#AF8052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#D89B60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "senderPlaceholderIcon_svg__h",
    x1: 51.5,
    x2: 51.5,
    y1: 49,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECD0",
    stopOpacity: 0
  })))));
};
export { SvgSenderPlaceholderIcon as ReactComponent };